import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseEditPopUpComponent } from '../../Services/BaseEditPopUpComponent';
import { ConfigService } from "../../Services/ConfigService";

@Component({
	selector: 'DeliveryZonePopUp',
	templateUrl: 'DeliveryZoneVisualPopUp.html',

})
export class DeliveryZoneVisualPopUpComponent extends BaseEditPopUpComponent  {

	constructor(
		public configData: ConfigService,
		private aModal: NgbActiveModal
	) {
		super();
		this.activeModal = aModal;

	}

	@Input()
	GroupID: string = '';

	@Input()
	CustomerID: string = '';

	_interactive: boolean = false;
	@Input()
	set Interactive(val: boolean) {
		this._interactive = val;
	} 

	@Input()
	zones: TooBig4Car.Logic.DeliveryZone[] =[];
}
